// app/javascript/controllers/new_event_select_client_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "modal", "submitButton", "form"]

  connect() {
  }


  showModal(event) {
    if (event.target.selectedOptions[0].text.includes("+ Create New Client")) {
      event.preventDefault()
      this.modalTarget.showModal()
      // Set back to the prompt option instead of empty string
      this.selectTarget.value = ""
      // Remove required temporarily while modal is open
      this.selectTarget.required = false
    } else {
      // Restore required if a real client is selected
      this.selectTarget.required = true
    }
  }

  closeModal() {
    this.modalTarget.close()
    // Restore required when modal closes
    this.selectTarget.required = true
    if (this.hasFormTarget) {
      this.formTarget.reset()
    }
  }


async createClient(event) {
  event.preventDefault()
  const form = event.target
  const submitButton = this.submitButtonTarget

  try {
    // Show loading state
    const originalText = submitButton.innerHTML
    submitButton.disabled = true
    submitButton.innerHTML = `
      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Creating...
    `

    const response = await fetch(form.action, {
      method: 'POST',
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
      },
      body: new FormData(form)
    })

    if (response.ok) {
      const html = await response.text()
      Turbo.renderStreamMessage(html) // Let Turbo handle the response
      this.closeModal()

      // Ensure the select element is required again
      if (this.hasSelectTarget) {
        this.selectTarget.required = true
        
        // If the select was updated with a new value, trigger change event
        setTimeout(() => {
          if (this.selectTarget.value) {
            const changeEvent = new Event('change', { bubbles: true })
            this.selectTarget.dispatchEvent(changeEvent)
          }
        }, 100) // Small delay to ensure DOM is updated
      }

      // Optional: Show success message
      const successMessage = document.createElement('div')
      successMessage.className = 'bg-green-50 p-4 rounded-md mb-4'
      successMessage.innerHTML = `
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-green-800">Client successfully created!</p>
          </div>
        </div>
      `
      form.closest('.w-1/3').insertBefore(successMessage, form)
      setTimeout(() => successMessage.remove(), 3000) // Remove after 3 seconds
    } else {
      // Handle error
      const errorData = await response.json()
      const errorMessage = document.createElement('div')
      errorMessage.className = 'bg-red-50 p-4 rounded-md mb-4'
      errorMessage.innerHTML = `
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-red-800">${errorData.error || 'An error occurred'}</p>
          </div>
        </div>
      `
      form.prepend(errorMessage)
      setTimeout(() => errorMessage.remove(), 3000)
    }
  } catch (error) {
    console.error("Error:", error)
  } finally {
    // Reset button state
    submitButton.disabled = false
    submitButton.innerHTML = originalText
  }
}
}
